import React, { Fragment, useContext } from "react";
import { PropTypes } from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import Navigation from "../../layouts/navigation/NavigationLayout";
import GlobalContext from "../../state/GlobalContext";
import PulseLoader from "react-spinners/PulseLoader";
import { colors } from "../../assets/theme";
import { Grid } from "@material-ui/core";

const styles = theme => ({
  main: {
    display: "flex",
    flex: 1,
    overflow: "scroll",
    backgroundColor: theme.palette.background.default,
    padding: 24,
    marginTop: 64,
    [theme.breakpoints.down("xs")]: {
      marginTop: 56,
      marginLeft: 0
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: 60
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: 220
    }
  },
  drawerPadding: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: 200
    }
  }
});

function PrivateRoute({
  admin,
  classes,
  component,
  exact,
  path,
  community,
  worker,
  partner
}) {
  const { session } = useContext(GlobalContext);
  const { user, loading } = session.state;
  if (!loading) {
    if (!session.state.isLoggedIn) {
      return <Redirect to="/" />;
    }
  }

  if (user && !loading) {
    if (session.state.isLoggedIn && user !== null && user) {
      const isAdmin = user.role === "admin";
      const isCommunity = user.role === "community";
      const isWorker = user.role === "worker";
      const isPartner = user.role === "partner";
      const isRedirected =
        (community && !isCommunity) ||
        (worker && !isWorker) ||
        (partner && !isPartner) ||
        (admin && !isAdmin);
      if (isRedirected && !isAdmin) return <Redirect to="/" />;
    }
  }

  const loadingPulse = (
    <Grid
      container
      justify="center"
      alignItems="center"
      style={{ height: 200 }}
    >
      <PulseLoader color={colors.LOADING} />
    </Grid>
  );

  return (
    <Route
      exact={exact}
      path={path}
      render={props => (
        <Fragment>
          <Navigation />
          <main className={classes.main}>
            {loading ? loadingPulse : React.createElement(component)}
          </main>
        </Fragment>
      )}
    />
  );
}

PrivateRoute.propTypes = {
  admin: PropTypes.bool,
  component: PropTypes.func.isRequired,
  exact: PropTypes.bool,
  path: PropTypes.string,
  rootAdmin: PropTypes.bool,
  content: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string
};

export default withStyles(styles)(PrivateRoute);
